
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"isolation":"isolate"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"isolation:isolate","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.579 12.344l-6.778 6.617a.578.578 0 01-.808-.002l-3.574-3.548a.559.559 0 01.002-.796l1.082-1.056a.578.578 0 01.808.002l2.101 2.084 5.288-5.164a.577.577 0 01.809.003l1.072 1.065a.553.553 0 01-.002.795zm2.516 9.407H3.907a.287.287 0 01-.287-.282V7.5h16.763v13.969c0 .155-.128.28-.287.28M20.383 3h-2.29V.563A.567.567 0 0017.524 0h-1.905a.568.568 0 00-.571.563V3H8.952V.563A.567.567 0 008.381 0H6.476a.57.57 0 00-.571.563V3H3.619C2.356 3 1.333 4.008 1.333 5.251v16.498C1.333 22.992 2.356 24 3.619 24h16.762c1.262 0 2.286-1.008 2.286-2.251V5.251c0-1.242-1.024-2.25-2.286-2.25","fill-rule":"evenodd"}})])
          )
        }
      }
    